import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { 
  ODataClient,
  ODataEntityService, 
  ODataEntity, 
  ODataEntities, 
  ODataProperty, 
  EntityKey,
  Duration,
  ODataEntityResource,
  ODataEntitySetResource,
  ODataNavigationPropertyResource,
  ODataActionResource,
  ODataFunctionResource,
  HttpOptions
} from 'angular-odata';

//#region ODataApi Imports
import { ArtikelAsset } from '../entities/articles/artikelasset.entity';
import { Asset } from '../entities/assets/asset.entity';
import { Artikel } from '../entities/artikel.entity';
import { Status } from '../entities/settings/status.entity';
import { StatusType } from '../entities/settings/statustype.entity';
//#endregion

@Injectable()
export class ArtikelAssetService extends ODataEntityService<ArtikelAsset> {
  constructor(protected client: ODataClient) {
    super(client, 'ArtikelAsset', 'entities.articles.ArtikelAsset');
  }

  
  
  //#region ODataApi Actions
  //#endregion
  //#region ODataApi Functions
  //#endregion
  //#region ODataApi Navigations
  public artikel(entity: EntityKey<ArtikelAsset>): ODataNavigationPropertyResource<Artikel> {
    return this.entity(entity).navigationProperty<Artikel>('artikel');
  }
  public asset(entity: EntityKey<ArtikelAsset>): ODataNavigationPropertyResource<Asset> {
    return this.entity(entity).navigationProperty<Asset>('asset');
  }
  public status(entity: EntityKey<ArtikelAsset>): ODataNavigationPropertyResource<Status> {
    return this.entity(entity).navigationProperty<Status>('status');
  }
  public statusType(entity: EntityKey<ArtikelAsset>): ODataNavigationPropertyResource<StatusType> {
    return this.entity(entity).navigationProperty<StatusType>('statusType');
  }
  //#endregion
}
